import React, { Component } from "react";
import { Icon } from "semantic-ui-react";
import LandingPageHead from "./components/Head";
import CardsWrapper from "./components/CardsWrapper";
import WhyJoinSection from "./components/WhyJoinSection";
import FeaturedDentists from "./components/FeaturedDentists";
import "./index.css";

class LandingPage extends Component {
  render() {
    return (
      <section className="landing-wrapper">
        <LandingPageHead />
        <div className="-inner">
          <header className="-section-head">
            <h2 className="-section-title">
              <Icon name="question circle outline" /> Why to join Casemasters?
            </h2>
          </header>
          <WhyJoinSection />
        </div>
        <div className="-inner">
          <header className="-section-head">
            <h2 className="-section-title">
              <Icon name="empty star" /> Featured Cases
            </h2>
          </header>
          <CardsWrapper />
        </div>
        <div className="-inner">
          <header className="-section-head">
            <h2 className="-section-title">
              <Icon name="user circle outline" /> Featured Dentists
            </h2>
          </header>
          <FeaturedDentists />
        </div>
      </section>
    );
  }
}

export default LandingPage;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/index.js